var Marionette = require('marionette');


/**
 * TODO: now seeThroughFill / color would apply but not in app yet and is done differently depending on the shape type --
 * original color is already set in a roundabout way
 * Maybe don't extend these, have a region for non common and show them ...
 */


module.exports = Marionette.LayoutView.extend({

    template: false,

    regions: {}, // even if none, leave to extends

    initialize: function(options) {

        this.shape = options.shape;

        this.channel = options.channel;

        // use as indicator to disable
        this.renderDisabled = options.renderDisabled;

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/baseShapePropertyView.js
 ** module id = 602
 ** module chunks = 0
 **/